import { BrowserUtility } from '@utility/browser-utility';
import { APIPath } from '@utility/constants/api';
import { CommonConstant } from '@utility/constants/common';
import { BaseServiceV2 } from '@utility/services/base-v2';
import type { CreateItemBody, CreateItemResult } from './types';

/** A `?useProd=true` session sends every call to the prod API, so the v1 base follows it, read at call time. */
const v1BaseUrl = () => {
  const apiPath = BrowserUtility.get(CommonConstant.useProd)
    ? import.meta.env.VITE_PROD_API_PATH
    : import.meta.env.VITE_API_PATH;

  return `${apiPath}/${import.meta.env.VITE_API_VERSION}`;
};

/**
 * BaseServiceV2 keeps the error's `details` (SKU_TAKEN's itemId), but its own base URL is /v2 and the API serves
 * catalog under /v1 only, so the call names the v1 base itself.
 */
export const createItemFromListing = (
  listingId: string,
  body: CreateItemBody,
) =>
  BaseServiceV2.post<CreateItemResult>(
    `${APIPath.catalogListings}/${encodeURIComponent(listingId)}/item`,
    body,
    true,
    v1BaseUrl(),
  );

/** The SKU is required; a title left empty takes the listing's. */
export function createItemBody(sku: string, title: string): CreateItemBody {
  const trimmedTitle = title.trim();

  return trimmedTitle
    ? { sku: sku.trim(), title: trimmedTitle }
    : { sku: sku.trim() };
}
